module.exports = __webpack_public_path__ + "src/assets/img/screen05.35e239ff.jpg";